import React from "react";

import { useTranslation } from "react-i18next";
import { StyledButton, CheckIcon } from "@aureskonnect/react-ui";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { mutate } from "swr";
import { toast } from "react-toastify";

import { DynamicTableWrapperContext, DominantColor } from "@components/Common/";

import { StatusActive } from "@constants/index";

type ConfirmUnBlockModalPropsType = {
    isOpen: boolean;
    setIsOpen: Function;
};

export default function ConfirmUnBlockModal({
    isOpen,
    setIsOpen,
}: ConfirmUnBlockModalPropsType) {
    const { t } = useTranslation();
    const dynamicTableWrapperContext = React.useContext(
        DynamicTableWrapperContext
    );
    const responsable = localStorage.getItem("Name");
    const [validateOnclick, setValidateOnclick] = React.useState<boolean>(true);
    const dominantColor: string = DominantColor();
    const userData = dynamicTableWrapperContext?.rowData?.original;
    let dataCustomerAccount: string = "";
    const customerAccountId = localStorage.getItem("customerAccountId");

    async function handleBlockUserAccountOnClickEvent(
        e: React.ChangeEvent<HTMLInputElement>
    ) {
        // Prevent Multiple Button Clicks
        e.currentTarget.disabled = true;
        const apiUrl = `${process.env.REACT_APP_ACCESS_API_URL}/update-user-status`;
        // Check if single or multi update action & set correspond URL request
        if (dynamicTableWrapperContext?.rowData?.original) {
            dataCustomerAccount += `'${dynamicTableWrapperContext?.rowData?.original.ID}'`;
        } else {
            Object.values(dynamicTableWrapperContext?.rowData).forEach(
                (userItem: any, index: number) => {
                    if (index !== 0) {
                        dataCustomerAccount += `, '${userItem.ID}'`;
                    } else {
                        dataCustomerAccount += `'${userItem.ID}'`;
                    }
                }
            );
        }
        if (validateOnclick) {
            setValidateOnclick(false);
            try {
                mutate(
                    apiUrl,
                    await fetch(apiUrl, {
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({
                            userAccountStatus: "Activer",
                            customerAccountUUid: dataCustomerAccount,
                        }),
                        method: "PUT",
                    })
                        .then((response) => response.json())
                        .then((data) => {
                            if (data.error) {
                                throw Error(
                                    "Error while unblocking user account !"
                                );
                            }
                            handleSavedUnBlockedHistoryOnClickEvent();
                            toast.success(
                                dynamicTableWrapperContext?.rowData?.original
                                    ? `${t(
                                          "The user account has been unblocked successfully"
                                      )!}`
                                    : `${t(
                                          "The user accounts have been unblocked successfully"
                                      )!}`,
                                {
                                    position: toast.POSITION.TOP_CENTER,
                                    autoClose: 2000,
                                    theme: "colored",
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    icon: (
                                        <CheckIcon
                                            height={25}
                                            width={25}
                                            fill="white"
                                        />
                                    ),
                                }
                            );

                            dynamicTableWrapperContext?.setDataUpdated(true);
                            dynamicTableWrapperContext?.setActionColumnDisplay(
                                false
                            );
                            setValidateOnclick(true);
                            setIsOpen(false);
                        })
                );
            } catch (e: any) {
                toast.error(`${t("Error while unlocking user account")}!`, {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 2000,
                    theme: "colored",
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
            }
        }
    }

    async function handleSavedUnBlockedHistoryOnClickEvent() {
        const apiUrl = `${process.env.REACT_APP_ACCESS_API_URL}/history`;
        let data: any = [];
        if (dynamicTableWrapperContext?.rowData?.original) {
            data = [
                {
                    typeHistory: 7,
                    oldData: {
                        Nom: `${dynamicTableWrapperContext?.rowData?.original.Nom}`,
                        Prénom: `${dynamicTableWrapperContext?.rowData?.original.Prénom}`,
                        Status: dynamicTableWrapperContext?.rowData?.original
                            .status,
                    },
                    newData: {
                        Nom: `${dynamicTableWrapperContext?.rowData?.original.Nom}`,
                        Prénom: `${dynamicTableWrapperContext?.rowData?.original.Prénom}`,
                        Status: StatusActive,
                    },
                    operator: responsable,
                    uidUpdatedData: `${dynamicTableWrapperContext?.rowData?.original.ID}`,
                },
            ];
        } else {
            Object.values(dynamicTableWrapperContext?.rowData).forEach(
                (userItem: any) => {
                    const data1 = {
                        typeHistory: 7,
                        oldData: {
                            Nom: `${userItem.Nom}`,
                            Prénom: `${userItem.Prénom}`,
                            Status: userItem.status,
                        },
                        newData: {
                            Nom: `${userItem.Nom}`,
                            Prénom: `${userItem.Prénom}`,
                            Status: StatusActive,
                        },
                        operator: responsable,
                        uidUpdatedData: `${userItem.ID}`,
                    };
                    data.push(data1);
                }
            );
        }

        try {
            mutate(
                apiUrl,
                await fetch(apiUrl, {
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        data,
                        customerAccountUUid: customerAccountId,
                    }),
                    method: "POST",
                })
                    .then((response) => response.json())
                    .then((data) => {
                        if (data.error) {
                            throw Error(
                                `${t("Error while archiving user account")}!`
                            );
                        }
                    })
            );
        } catch (e: any) {
            toast.error(`${t("Error while archiving user account")}!`, {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
                theme: "colored",
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }
    }

    return (
        <Modal centered isOpen={isOpen}>
            <ModalHeader toggle={(): boolean => setIsOpen(!isOpen)}>
                <span className="text-uppercase cmn_txt_titleAlert">
                    {t("Confirmation")}
                    {dynamicTableWrapperContext?.rowData?.title}
                </span>
            </ModalHeader>
            <ModalBody className="cmn_txt_descriptionAlert">
                {userData
                    ? `${t(
                          "Do you want to confirm the unblocking of the user account"
                      )}${userData?.Nom} ${userData?.Prénom} `
                    : t(
                          "Do you want to confirm the unblocking of the selected user accounts ?"
                      )}
            </ModalBody>
            <ModalFooter className="border-top-0">
                <StyledButton
                    className="cmn_btn_cancelAlert"
                    onClick={() => {
                        setIsOpen(!isOpen);
                    }}
                    rounded
                    variant="light"
                    outline
                >
                    {t("Cancel")}
                </StyledButton>

                <StyledButton
                    className="cmn_btn_validateAlert"
                    onClick={(e: React.ChangeEvent<HTMLInputElement>) => {
                        handleBlockUserAccountOnClickEvent(e);
                    }}
                    rounded
                    variant={dominantColor}
                >
                    {t("Validate")}
                </StyledButton>
            </ModalFooter>
        </Modal>
    );
}
